<template>
    <div>
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']">
            {{inputLbl.name}}
        </div>
        <div class="relative pb-5">
            <input type="text"
                class="w-full bg-white px-3 py-1 placeholder-gray-500"
                :class="[isError ? 'border border-red-500' : 'border']"
                v-model="content"
                :placeholder="inputLbl.placeholder"
                :maxlength="inputMaxLength"
                :data-cy="$attrs['data-cy'] || inputLbl.name"
                @input="onChange()">
            <div class="text-red-500 text-sm absolute bottom-0 left-0 w-full" v-if="isError">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputEmail",
    props: {
        // v-model
        inputValue:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: null,
        };
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required
                && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.content && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                if (!RegxHelper.isEmailFormat(this.content)) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.invalid);
                    return;
                }
            }
        },
        onChange: function() {
            let result = this.content;

            this.validateInput();
            this.$emit('update:inputValue', result);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
